import styled from 'styled-components';

const NavHeadng = styled.label`
  display: block;
  font-size: 1rem;
  line-height: 1.4;
  margin: 0 0 10px;
  text-align: center;
  width: 100%;
`;

export default NavHeadng;
